export function removeNode(el) {
  var parent = el.parentNode;

  if (parent) {
    parent.removeChild(el);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/utils/dom/node.js
// module id = null
// module chunks = 